export default "__VITE_ASSET__B2b0Sofy__"